import Pusher from 'pusher-js'
import EventEmitter from 'events'
import helper from '../helper'
import StoreCommiter from 'laravel-vuex/store-commiter'

class Channels extends EventEmitter {
  init ({nexus, store, pusher}) {
    this.nexus = nexus
    this.store = store
    this.key = pusher

    this.heartbeatTimer = 5 * 60 * 1000

    this._handleNexusEvents()
    this._heartbeat()

    this.connected = false
  }

  connect () {
    let self = this

    if (this.connected) {
      return false
    }

    console.log('[ CHANNEL ] Connecting ...')

    this.nexus.axios.get(helper.url('api', 'account/users/current'))
      .then((response) => {
        let user = response.data.data

        self.socket = self._getSocket()

        let privateGlobalChannel = self.socket.subscribe('private-global')
        let privateUserChannel = self.socket.subscribe('private-user.' + user.id)

        privateGlobalChannel.bind_global(function (event, data) {
          if (event === 'laravel.vuex:mutation') {
            StoreCommiter.commit(self.store, data, true)
          } else {
            console.log('[ CHANNEL ] Got global event : ' + event)
            self.emit('global-event', {name: event, data})
          }
        })

        privateUserChannel.bind_global(function (event, data) {
          if (event === 'laravel.vuex:mutation') {
            StoreCommiter.commit(self.store, data, true)
          } else {
            console.log('[ CHANNEL ] Got user event : ' + event)
            self.emit('user-event', {name: event, data})
          }
        })

        this.connected = true
      })
  }

  disconnect () {
    if (!this.connected) {
      return false
    }

    console.log('[ CHANNEL ] Disconnecting ...')

    if (typeof this.socket !== 'undefined') {
      this.socket.disconnect()
    }

    this.connected = false
  }

  reconnect () {
    this.disconnect()
    this.connect()
  }

  _heartbeat () {
    let self = this

    if (!this.connected) {
      setTimeout(() => {
        self._heartbeat()
      }, this.heartbeatTimer)

      return false
    }

    console.log('[ CHANNEL ] Running Heartbeat ...')

    this.nexus.axios.get(helper.url('api', 'account/users/current'))
      .then((response) => {
        let user = response.data.data
        let privateUserChannel = self.socket.channel('private-user.' + user.id)

        let timeout = setTimeout(() => {
          console.log('[ CHANNEL ] Heartbeat failed, trying a reconnect ...')
          privateUserChannel.unbind('pong')
          this.reconnect() // TODO : Handle if the reconnect fails ?
        }, 500)

        privateUserChannel.bind('pong', () => {
          console.log('[ CHANNEL ] Heartbeat success !')
          privateUserChannel.unbind('pong')
          clearTimeout(timeout)
          setTimeout(() => {
            self._heartbeat()
          }, this.heartbeatTimer)
        })

        this.nexus.axios.post(helper.url('api', 'account/channels/ping'))
      })
  }

  _handleNexusEvents () {
    let self = this

    this.nexus.on('connected', () => {
      self.connect()
    })
    this.nexus.on('disconnected', () => {
      self.disconnect()
    })
  }

  _getSocket () {
    return new Pusher(this.key, {
      cluster: 'eu',
      encrypted: true,
      authEndpoint: helper.url('api', 'account/channels/auth'),
      auth: {
        headers: {
          'Authorization': 'Bearer ' + this.nexus.getToken()
        }
      }
    })
  }
}

export let channels = new Channels()



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/nexus-js-v1/transport/channels.js
// module id = 220
// module chunks = 1